import styled from 'styled-components';
import QButton from '_Components/Buttons/QButton/QButton';

export const StyledQButton = styled(QButton)`
  visibility: ${({ hide }) => (hide ? 'hidden' : 'visible')};
`;
